export default __webpack_public_path__ + "static/media/ship-1.196f6375.png";